export const userflowIds = {
    attachButton: "compose-attach-button",
    contactDetailsButton: "compose-contact-details-button",
    patientResponseCheckbox: "compose-patient-response-checkbox",
    templatesButton: "compose-templates-button",
    bookingLinkButton: "compose-booking-link-button",
};
